export const TYPE_NUMBER = '[object Number]';
export const TYPE_STRING = '[object String]';
export const TYPE_ARRAY = '[object Array]';
export const TYPE_OBJECT = '[object Object]';
